import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Forgot, Form, LoginSection, Title, Subtitle } from './LoginStyles';
import DefaultInput from '../Inputs/DefaultInput';
import ButtonComponent from '../Buttons/ButtonComponent';
import { recoverPassword } from '../../services/AuthService';
import ToastService from '../../services/ToastService';
import { loginSuccess } from '.././../redux/user/user.actions';

const validation = values => {
  const errors = {};
  if (!values.email) {
    errors.email = 'REQUIRED';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'INVALID_ADDRESS';
  }
  return errors;
};

class RecoverForm extends React.Component {
  state = {
    loading: false
  };

  onSubmit = values => {
    const { toggle } = this.props;
    this.setState({ loading: true }, () => {
      recoverPassword(values)
        .then(result => {
          ToastService.success('An email was sent with the new credentials');
          this.setState({ loading: false }, toggle);
        })
        .catch(error => {
          if(error.message!=='USER_NOT_FOUND'){
            ToastService.error('An error occurred, please try again later');
            this.setState({ loading: false });
          } else {
            ToastService.error('User was not found. Please check the e-mail address.');
            this.setState({ loading: false });
          }
        });
    });
  };

  render() {
    const { handleSubmit, toggle } = this.props;
    const { loading } = this.state;
    this.props.change("site", 2);
    return (
      <LoginSection>
        <Title>Recover Password!</Title>
        <Subtitle>
          Please give us our email and will receive a new password to login.
        </Subtitle>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            component={DefaultInput}
            name="email"
            type="email"
            label="Email"
          />
               
          <Forgot onClick={toggle}>Login?</Forgot>
          <ButtonComponent loading={loading} width="180px" label="Send" />
        </Form>
      </LoginSection>
    );
  }
}

RecoverForm = reduxForm({
  form: 'recover_form',
  enableReinitialize: true,
  validate: validation
})(RecoverForm);

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

const mapActionToProps = dispatch =>
  bindActionCreators({ loginSuccess }, dispatch);

RecoverForm = connect(
  mapStateToProps,
  mapActionToProps
)(RecoverForm);

export default withRouter(RecoverForm);



// WEBPACK FOOTER //
// ./src/components/Login/RecoverForm.js